import React from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import { StripeProvider } from './contexts/StripeContext';
import { Routes } from './Routes';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <StripeProvider>
          <Routes />
        </StripeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;